//
const jalali = require('jalaali-js');

module.exports = {
  toJalaali,
  toMiladi,
  isValidJalaaliDate,
  getCurrentWeek,
  getWeekAgo
}

function toJalaali(_date) {

  let _return;
  let date = new Date(_date);
  let day = date.getDay();

  let r = jalali.toJalaali(Number(date.getFullYear()), Number(date.getMonth() + 1), Number(date.getDate()));
  if (r.jm < 10)
    r.jm = '0' + String(r.jm);
  if (r.jd < 10)
    r.jd = '0' + String(r.jd);

  let hour = date.getHours(),
    min = date.getMinutes(),
    second = date.getSeconds();

  // add zero to little numbers
  if (hour < 10)
    hour = '0' + String(hour);
  if (min < 10)
    min = '0' + String(min);
  if (second < 10)
    second = '0' + String(second);

  //
  const weekday = [
    "یکشنبه",
    "دوشنبه",
    "سه شنبه",
    "چهارشنبه",
    "پنجشنبه",
    "جمعه",
    "شنبه"
  ];
  _return = {
    full_date: `${hour}:${min} - ${r.jy}/${r.jm}/${r.jd}`,
    date: `${r.jy}/${r.jm}/${r.jd}`,
    time: `${hour}:${min}:${second}`,
    second_less_time: `${hour}:${min}`,
    dayOfWeek: weekday[day]
  }
  // console.log(_return);

  return _return
}

function toMiladi(_date) {

  if (!_date || _date.length < 10) {
    return {
      err: {
        status: 400,
        err: new Error('low args')
      }
    };
  }
  //
  let date = _date.split("/");
  let j = {
    year: date[0],
    month: date[1],
    day: date[2]
  }
  //validation
  let _valid = jalali.isValidJalaaliDate(j.year, j.month, j.day);
  if (_valid === false) {
    return {
      err: {
        status: 400,
        err: new Error('no validate')
      }
    };
  }
  //convert to miladi
  let miladi = jalali.toGregorian(Number(j.year), Number(j.month), Number(j.day));

  return (new Date(miladi.gy, miladi.gm - 1, miladi.gd))
}

function isValidJalaaliDate(_jalaali) {
  if (_jalaali.length < 10) {
    return false;
  }
  let date = _jalaali.split("/");
  let j = {
    year: date[0],
    month: date[1],
    day: date[2]
  }
  //validation
  let valid = jalali.isValidJalaaliDate(j.year, j.month, j.day);
  if (valid === false) {
    return false;
  }
  //
  return true

}

function getCurrentWeek() {
  const today = new Date();
  // Get the first day of the current week (saturday)
  const firstDay = new Date(today.setDate(today.getDate() - today.getDay() - 1));
  const today2 = new Date();
  // Get the last day of the current week (friday)
  const lastDay = new Date(today2.setDate(today2.getDate() - today2.getDay() + 6 - 1));
  return {saturday: toJalaali(firstDay), friday: toJalaali(lastDay)}
}

function getWeekAgo() {
  const today = new Date();
  // Get the first day of the week ago (saturday)
  const firstDay = new Date(today.setDate(today.getDate() - today.getDay() - 1 - 7));
  const today2 = new Date();
  // Get the last day of the week ago (friday)
  const lastDay = new Date(today2.setDate(today2.getDate() - today2.getDay() + 6 - 1 - 7));
  return {saturday: toJalaali(firstDay), friday: toJalaali(lastDay)}
}
